import { Box, Grid, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "../../../components/button/Button";
import { useToast } from "../../../context/toast/ToastContext";
import {
  useAddHistoryGrouping,
  useUpdateHistoryGrouping,
} from "../network/resolver";
import { IGroupingHistory } from "../network/ProdukDetail.type";
import { useEffect } from "react";

export interface FormGroupingHistory {
  grouping_product_id: number;
  quantity: number;
  notes: string;
  status: number;
}

interface InsertGroupingProps {
  groupingProductId?: number;
  groupHistory?: IGroupingHistory;
  onSubmit(): void;
}

export default function InsertHistoryGrouping({
  groupingProductId,
  groupHistory,
  onSubmit,
}: InsertGroupingProps) {
  const toast = useToast();
  const { control, handleSubmit, getValues, setValue } =
    useForm<FormGroupingHistory>();
  const { mutateAsync: mutateAdd, isLoading: loadingAdd } =
    useAddHistoryGrouping();
  const { mutateAsync: mutateUpdate, isLoading: loadingUpdate } =
    useUpdateHistoryGrouping();
  const loading = loadingAdd || loadingUpdate;

  useEffect(() => {
    if (groupHistory) {
      setValue("notes", groupHistory.notes);
      setValue("quantity", groupHistory.quantity);
    }
  }, [groupHistory]);

  const handleFormSubmit = async () => {
    if (getValues("quantity") === undefined) {
      toast.show("Mohon Melengkapi Form");
      return;
    }
    if (groupHistory) {
      await mutateUpdate({
        id: groupHistory.id,
        quantity: getValues("quantity"),
        notes: getValues("notes"),
        status: 1,
      });
    } else {
      await mutateAdd({
        grouping_product_id: groupingProductId as any,
        quantity: getValues("quantity"),
        notes: getValues("notes"),
        status: 1,
      });
    }
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Grid container spacing={2}>
        <Grid item xl={12} width={"100%"}>
          <Controller
            rules={{ required: "Mohon Mengisi Jumlah" }}
            control={control}
            name="quantity"
            render={(field) => (
              <TextField
                value={field.field.value}
                fullWidth
                type="number"
                placeholder="Jumlah"
                label="Jumlah"
                onChange={(e) => field.field.onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item xl={12} width={"100%"}>
          <Controller
            control={control}
            name="notes"
            render={(field) => (
              <TextField
                value={field.field.value}
                rows={4}
                multiline
                fullWidth
                placeholder="Catatan"
                label="Catatan"
                onChange={(e) => field.field.onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"flex-end"} width={"100%"}>
            <LoadingButton
              isLoading={loading}
              text={groupHistory ? "Update" : "Submit"}
              onClick={() => handleFormSubmit()}
            />
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}
